import React from 'react'

const Manual_cambiar_logos_ecommerce = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
      <div className="mt-16">
        <h2 className="font-bold xl-text-[40px] lg:text-4xl text-4xl text-[#002D33] mb-5">
          Cambiar logos dentro del e-commerce
        </h2>
        <p className="text-lg text-gray-700 mb-6">
          Aprende a reemplazar los logotipos de tu tienda online desde el panel de diseño de Clau.io.
        </p>
        <iframe
          src="https://scribehow.com/embed/Cambiar_logos_dentro_del_e-commerce__utQvsNcoRbeB47Siz0kdeg?as=scrollable"
          className="scribe-iframe-general-119"
          width="100%"
          height="6900"
          allowFullScreen
          style={{ border: 0, minHeight: '640px' }}
        ></iframe>
      </div>
    </div>
  )
}

export default Manual_cambiar_logos_ecommerce
